import * as THREE from 'three';

// Project the actual occupied bounds, then use the largest zoom that fits the
// available rectangle. This works for every board aspect ratio and die position.
export const createBoardCameraFramer = () => {
  const projection = new THREE.PerspectiveCamera();
  const point = new THREE.Vector3();
  return (
    camera,
    points,
    width,
    height,
    { top = 12, bottom = 12, side = 12 } = {}
  ) => {
    projection.copy(camera);
    projection.zoom = 1;
    projection.clearViewOffset();
    projection.updateProjectionMatrix();
    projection.updateMatrixWorld(true);
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    points.forEach((position) => {
      point.copy(position).project(projection);
      minX = Math.min(minX, point.x);
      maxX = Math.max(maxX, point.x);
      minY = Math.min(minY, point.y);
      maxY = Math.max(maxY, point.y);
    });
    const left = -1 + (2 * side) / width;
    const right = 1 - (2 * side) / width;
    const upper = 1 - (2 * top) / height;
    const lower = -1 + (2 * bottom) / height;
    const zoom = Math.min(
      (right - left) / Math.max(0.001, maxX - minX),
      (upper - lower) / Math.max(0.001, maxY - minY)
    );
    const shiftX = (left + right - (minX + maxX) * zoom) / 2;
    const shiftY = (upper + lower - (minY + maxY) * zoom) / 2;
    camera.zoom = zoom;
    camera.setViewOffset(
      width,
      height,
      (-shiftX * width) / 2,
      (shiftY * height) / 2,
      width,
      height
    );
    camera.updateProjectionMatrix();
    return zoom;
  };
};
